import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-payment-monthly-subscription',
  templateUrl: './payment-monthly-subscription.component.html',
  styleUrls: ['./payment-monthly-subscription.component.scss']
})
export class PaymentMonthlySubscriptionComponent implements OnInit {
  sectionTitle = 'Payment'
  paymentMonthlyTitle = "Monthly Subscription"
  paymentMonthlysubtitle = "Ex of 1st of each month"

  s
  constructor() { }

  ngOnInit() {
  }

}
